// Survey page flow: step navigation, answer state, submit.
document.addEventListener('DOMContentLoaded', () => {
    const root = document.querySelector('.s-survey');
    if (!root) return;

    const dataEl = document.getElementById('js-survey-data');
    if (!dataEl) return;

    const questions = JSON.parse(dataEl.textContent || '[]');
    const answers = {};

    questions.forEach((q) => {
        answers[q.id] = { optionIds: new Set(), otherText: null };
    });

    const stepIntro = root.querySelector('.s-survey__step[data-step="intro"]');
    const stepCard = root.querySelector('.s-survey__step[data-step="card"]');
    const stepQuestion = root.querySelector('.s-survey__step[data-step="question"]');
    const stepThanks = root.querySelector('.s-survey__step[data-step="thanks"]');

    if (root.dataset.alreadyCompleted === '1') {
        showStep('thanks');
        return;
    }

    function showStep(name) {
        root.querySelectorAll('.s-survey__step').forEach((s) => s.classList.remove('is-active'));
        const target = root.querySelector(`.s-survey__step[data-step="${name}"]`);
        if (target) {
            target.classList.add('is-active');
            window.scrollTo({ top: 0 });
        }
    }

    let currentIndex = 0;

    function renderQuestion(index) {
        currentIndex = index;
        const q = questions[index];

        const counterEl = stepQuestion.querySelector('[data-role="counter"]');
        const textEl = stepQuestion.querySelector('[data-role="question-text"]');
        const optionsEl = stepQuestion.querySelector('[data-role="options"]');
        const otherInput = stepQuestion.querySelector('[data-role="other-input"]');

        if (counterEl) counterEl.textContent = `Pytanie: ${index + 1}/${questions.length}`;
        if (textEl) textEl.textContent = q.text;

        optionsEl.innerHTML = '';
        otherInput.hidden = true;
        otherInput.value = '';

        const savedAnswer = answers[q.id];

        q.options.forEach((opt) => {
            const el = document.createElement('div');
            el.className = 's-survey__option';
            el.textContent = opt.text;
            el.dataset.optionId = String(opt.id);

            if (savedAnswer.optionIds.has(opt.id)) {
                el.classList.add('is-selected');
            }

            el.addEventListener('click', () => handleOptionClick(q, opt.id, el));
            optionsEl.appendChild(el);
        });

        if (q.allowOther) {
            const otherEl = document.createElement('div');
            otherEl.className = 's-survey__option';
            otherEl.textContent = q.otherLabel || 'Inne (proszę podać)';
            otherEl.dataset.optionId = 'other';

            const isOtherSelected = savedAnswer.otherText !== null;
            if (isOtherSelected) {
                otherEl.classList.add('is-selected');
                otherInput.hidden = false;
                otherInput.value = savedAnswer.otherText || '';
            }

            otherEl.addEventListener('click', () => handleOtherClick(q, otherEl));
            optionsEl.appendChild(otherEl);
        }

        stepQuestion.classList.remove('has-error');
        showStep('question');
    }

    function handleOptionClick(q, optionId, el) {
        const otherInput = stepQuestion.querySelector('[data-role="other-input"]');
        const savedAnswer = answers[q.id];

        if (q.multiple) {
            if (el.classList.contains('is-selected')) {
                el.classList.remove('is-selected');
                savedAnswer.optionIds.delete(optionId);
            } else {
                el.classList.add('is-selected');
                savedAnswer.optionIds.add(optionId);
            }
        } else {
            stepQuestion.querySelectorAll('[data-role="options"] .s-survey__option').forEach((o) => {
                o.classList.remove('is-selected');
            });
            el.classList.add('is-selected');

            savedAnswer.optionIds.clear();
            savedAnswer.optionIds.add(optionId);

            otherInput.hidden = true;
            otherInput.value = '';
            savedAnswer.otherText = null;
        }

        stepQuestion.classList.remove('has-error');
    }

    function handleOtherClick(q, otherEl) {
        const otherInput = stepQuestion.querySelector('[data-role="other-input"]');
        const savedAnswer = answers[q.id];

        if (q.multiple) {
            if (otherEl.classList.contains('is-selected')) {
                otherEl.classList.remove('is-selected');
                otherInput.hidden = true;
                otherInput.value = '';
                savedAnswer.otherText = null;
            } else {
                otherEl.classList.add('is-selected');
                otherInput.hidden = false;
                otherInput.focus();
                savedAnswer.otherText = '';
            }
        } else {
            stepQuestion.querySelectorAll('[data-role="options"] .s-survey__option').forEach((o) => {
                o.classList.remove('is-selected');
            });
            otherEl.classList.add('is-selected');
            savedAnswer.optionIds.clear();
            savedAnswer.otherText = '';
            otherInput.hidden = false;
            otherInput.value = '';
            otherInput.focus();
        }

        stepQuestion.classList.remove('has-error');
    }

    function validateCurrentQuestion() {
        const q = questions[currentIndex];
        const savedAnswer = answers[q.id];
        const otherInput = stepQuestion.querySelector('[data-role="other-input"]');
        const otherOption = stepQuestion.querySelector('[data-role="options"] [data-option-id="other"]');
        const isOtherSelected = otherOption && otherOption.classList.contains('is-selected');

        if (isOtherSelected) {
            const otherText = otherInput.value.trim();
            if (!otherText) return false;
            savedAnswer.otherText = otherText;
        }

        if (q.required) {
            const hasRealOption = savedAnswer.optionIds.size > 0;
            const hasOther = isOtherSelected && otherInput.value.trim() !== '';
            if (!hasRealOption && !hasOther) return false;
        }

        return true;
    }

    function saveCurrentOtherText() {
        const q = questions[currentIndex];
        const savedAnswer = answers[q.id];
        const otherInput = stepQuestion.querySelector('[data-role="other-input"]');
        const otherOption = stepQuestion.querySelector('[data-role="options"] [data-option-id="other"]');
        if (otherOption && otherOption.classList.contains('is-selected')) {
            savedAnswer.otherText = otherInput.value.trim() || '';
        }
    }

    async function submitSurvey() {
        const nextBtn = stepQuestion.querySelector('[data-action="answer-next"]');
        if (nextBtn) {
            nextBtn.disabled = true;
        }

        const payload = {
            answers: questions.map((q) => {
                const ans = answers[q.id];
                return {
                    questionId: q.id,
                    optionIds: Array.from(ans.optionIds).map(Number),
                    otherText: ans.otherText && ans.otherText.trim() ? ans.otherText.trim() : null,
                };
            }),
        };

        try {
            const resp = await fetch('/api/survey/submit', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: JSON.stringify(payload),
            });

            if (resp.ok) {
                const data = await resp.json();
                if (data.ok) {
                    showStep('thanks');
                    return;
                }
            }

            if (resp.status === 409) {
                showStep('thanks');
                return;
            }

            showSubmitError(nextBtn);
        } catch {
            showSubmitError(nextBtn);
        }
    }

    function showSubmitError(nextBtn) {
        if (nextBtn) nextBtn.disabled = false;

        let errorEl = stepQuestion.querySelector('.s-survey__submit-error');
        if (!errorEl) {
            errorEl = document.createElement('p');
            errorEl.className = 's-survey__submit-error';
            nextBtn ? nextBtn.parentNode.insertBefore(errorEl, nextBtn) : stepQuestion.appendChild(errorEl);
        }
        errorEl.textContent = 'Coś poszło nie tak, spróbuj ponownie.';
        errorEl.hidden = false;
    }

    function clearSubmitError() {
        const errorEl = stepQuestion.querySelector('.s-survey__submit-error');
        if (errorEl) errorEl.hidden = true;
    }

    if (stepIntro) {
        const nextBtn = stepIntro.querySelector('[data-action="next"]');
        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                if (stepCard) {
                    showStep('card');
                } else {
                    if (questions.length > 0) renderQuestion(0);
                }
            });
        }
    }

    if (stepCard) {
        const nextBtn = stepCard.querySelector('[data-action="next"]');
        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                if (questions.length > 0) renderQuestion(0);
            });
        }
    }

    if (stepQuestion) {
        const backBtn = stepQuestion.querySelector('[data-action="back"]');
        if (backBtn) {
            backBtn.addEventListener('click', () => {
                saveCurrentOtherText();
                if (currentIndex === 0) {
                    if (stepCard) {
                        showStep('card');
                    } else {
                        showStep('intro');
                    }
                } else {
                    renderQuestion(currentIndex - 1);
                }
            });
        }

        const answerNextBtn = stepQuestion.querySelector('[data-action="answer-next"]');
        if (answerNextBtn) {
            answerNextBtn.addEventListener('click', () => {
                saveCurrentOtherText();
                clearSubmitError();

                if (!validateCurrentQuestion()) {
                    stepQuestion.classList.add('has-error');
                    return;
                }

                stepQuestion.classList.remove('has-error');

                if (currentIndex === questions.length - 1) {
                    submitSurvey();
                } else {
                    renderQuestion(currentIndex + 1);
                }
            });
        }
    }

    showStep('intro');
});
